"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Util = void 0;
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const boundingBox_js_1 = require("../boundingBox.js");
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const PointLocator_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocator.js"));
const Location_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Location.js"));
class Util {
    //point->LTPoint
    //line->Array<LTPoint>
    static addPointToLine(point, line) {
        //判断点是否与多段线上的任一点相等，不相等
        for (let p of line) {
            if (point.equalsFuzzy(p, 1e-4)) {
                return true;
            }
        }
        if (line.length === 2) {
            line.splice(1, 0, point);
            return true;
        }
        //点数大于2，则判断属于哪段线
        else {
            for (let i = 0; i < line.length - 1; i++) {
                if (this.isPointOnSegment_V2(point, [line[i], line[i + 1]])) {
                    line.splice(i + 1, 0, point);
                    return true;
                }
            }
        }
        return false;
    }
    //仅用于判断点该插在多段线上的哪一段（多段线为一条直线）
    static isPointOnSegment_V2(point, segment) {
        let boundingBox = new boundingBox_js_1.BoundingBox();
        for (let p of segment) {
            boundingBox.expand(p);
        }
        return boundingBox.contains(point);
    }
    //两个线段是否在同一范围
    static isTwoSegmentsNotInSameRange(seg1, seg2) {
        let minx_s1 = Math.min(seg1[0].x, seg1[seg1.length - 1].x);
        let maxx_s1 = Math.max(seg1[0].x, seg1[seg1.length - 1].x);
        let miny_s1 = Math.min(seg1[0].y, seg1[seg1.length - 1].y);
        let maxy_s1 = Math.max(seg1[0].y, seg1[seg1.length - 1].y);
        let minx_s2 = Math.min(seg2[0].x, seg2[seg2.length - 1].x);
        let maxx_s2 = Math.max(seg2[0].x, seg2[seg2.length - 1].x);
        let miny_s2 = Math.min(seg2[0].y, seg2[seg2.length - 1].y);
        let maxy_s2 = Math.max(seg2[0].y, seg2[seg2.length - 1].y);
        return minx_s1 > maxx_s2 || minx_s2 > maxx_s1 || miny_s1 > maxy_s2 || miny_s2 > maxy_s1;
    }
    //移除重复线段
    static removeRepeatSegments(lines) {
        for (let i = lines.length - 1; i > 0; i--) {
            let seg1 = lines[i];
            for (let j = i - 1; j >= 0; j--) {
                let seg2 = lines[j];
                if (seg1 === seg2 || seg1.length != seg2.length) {
                    continue;
                }
                let head_tail_equals = seg1[0].equals(seg2[0]) && seg1[seg1.length - 1].equals(seg2[seg2.length - 1]);
                let head_tail_equals_reverse = false;
                if (head_tail_equals === false) {
                    head_tail_equals_reverse = seg1[0].equals(seg2[seg2.length - 1]) && seg1[seg1.length - 1].equals(seg2[0]);
                }
                let isLineEquals = true;
                if (head_tail_equals) {
                    for (let k = 0; k < seg1.length; k++) {
                        if (!seg1[k].equals(seg2[k])) {
                            isLineEquals = false;
                            break;
                        }
                    }
                }
                else if (head_tail_equals_reverse) {
                    for (let k = 0; k < seg1.length; k++) {
                        if (!seg1[k].equals(seg2[seg1.length - 1 - k])) {
                            isLineEquals = false;
                            break;
                        }
                    }
                }
                else {
                    continue;
                }
                if (isLineEquals) {
                    lines.splice(i, 1);
                    break;
                }
            }
        }
    }
    //截断坐标值到指定精度
    static fixedPrecisionForAllPoints(lines) {
        let newLines = new Array();
        for (let line of lines) {
            let newLine = new Array();
            for (let point of line) {
                newLine.push(new ltpoint_1.LTPoint(Number(point.x.toFixed(4)), Number(point.y.toFixed(4))));
            }
            newLines.push(newLine);
        }
        return newLines;
    }
    //将多段线打断
    static breakUpToTwoPointsSegments(lines) {
        let segments = new Array();
        for (let line of lines) {
            for (let i = 0; i < line.length - 1; i++) {
                let segment = [line[i].clone(), line[i + 1].clone()];
                segments.push(segment);
            }
        }
        return segments;
    }
    //计算线段交点
    static computeLineSegmentLineSegmentIntersection(p0, p1, q0, q1) {
        let x00 = p0.x;
        let y00 = p0.y;
        let x01 = p1.x;
        let y01 = p1.y;
        let x10 = q0.x;
        let y10 = q0.y;
        let x11 = q1.x;
        let y11 = q1.y;
        const numerator1A = (x11 - x10) * (y00 - y10) - (y11 - y10) * (x00 - x10);
        const numerator1B = (x01 - x00) * (y00 - y10) - (y01 - y00) * (x00 - x10);
        const denominator1 = (y11 - y10) * (x01 - x00) - (x11 - x10) * (y01 - y00);
        // If denominator = 0, then lines are parallel. If denominator = 0 and both numerators are 0, then coincident
        if (denominator1 === 0) {
            return undefined;
        }
        const ua1 = numerator1A / denominator1;
        const ub1 = numerator1B / denominator1;
        if (ua1 >= 0 && ua1 <= 1 && ub1 >= 0 && ub1 <= 1) {
            let x = x00 + ua1 * (x01 - x00);
            let y = y00 + ua1 * (y01 - y00);
            return new ltpoint_1.LTPoint(x, y);
        }
        return undefined;
    }
    //要求参数line的点数为2
    static RemoveZeroLengthSegments(lines) {
        for (let i = lines.length - 1; i >= 0; i--) {
            let line = lines[i];
            if (line[0].equalsFuzzy(line[1], 1e-4)) {
                lines.splice(i, 1);
            }
        }
    }
    //角度制，atan2计算出来的范围是[-180~180]，为了方便计算，调整到(-90~90]
    static computeAngle(p1, p2) {
        let vector = new Vector2D_js_1.default(p1, p2);
        let angle = vector.angle();
        if (angle > Math.PI / 2) {
            angle -= Math.PI;
        }
        else if (angle <= -Math.PI / 2) {
            angle += Math.PI;
        }
        return angle * 180 / Math.PI;
    }
    static isTwoSegmentsEquals(seg1, seg2) {
        if (seg1.p0.equals2D(seg2.p0, 0.1) && seg1.p1.equals2D(seg2.p1, 0.1)) {
            return true;
        }
        else if (seg1.p0.equals2D(seg2.p1, 0.1) && seg1.p1.equals2D(seg2.p0, 0.1)) {
            return true;
        }
        return false;
    }
    //判断第一个多边形是否包含第二个多边形（这里不判断哪个比较大）
    static isPolygonContainsAnother(polygon1, polygon2) {
        let pointLocator = new PointLocator_js_1.default();
        let shell = polygon1.getExteriorRing();
        let pointsOfPolygon2 = polygon2.getExteriorRing().getCoordinates();
        for (let point of pointsOfPolygon2) {
            if (pointLocator.locateInPolygonRing(point, shell) == Location_js_1.default.EXTERIOR) {
                return false;
            }
        }
        return true;
    }
}
exports.Util = Util;
